module.exports = __webpack_public_path__ + "img/sub-features-3.85c6edd.jpg";